import { authConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

// login
export const sigin_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.LOGIN_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.login, data);
    if (response.status) {
      let data = response?.data;
      localStorage.setItem("jigsawUser", JSON.stringify(data));
      dispatch({
        type: authConstants.LOGIN_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: authConstants.USER_META_DATA_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.LOGIN_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//signup
export const signup_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.SIGNUP_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.signup, data);
    if (response.status) {
      dispatch({
        type: authConstants.SIGNUP_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      localStorage.setItem("jigsawUser", JSON.stringify(response.data));
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.SIGNUP_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//reset password user
export const reset_password_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.RESET_PASSWORD_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.resetPassword, data);
    if (response.status) {
      dispatch({
        type: authConstants.RESET_PASSWORD_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.RESET_PASSWORD_USER_ACTION_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//reset password confirm
export const reset_password_confirm_user_action =
  (data) => async (dispatch) => {
    dispatch({
      type: authConstants.RESET_PASSWORD_CONFIRM_USER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        `${config.auth.resetPasswordConfirm}${data.uid}/${data.token}/`,
        data
      );

      if (response.status) {
        showSuccessMessage("Password has been reset");
        dispatch({
          type: authConstants.RESET_PASSWORD_CONFIRM_USER_ACTION_SUCCESS,
          payload: response.data,
        });
        localStorage.removeItem("jigsawUser");

        return true;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: authConstants.RESET_PASSWORD_CONFIRM_USER_ACTION_FAILURE,
        payload: e,
      });
      showWarningMessage(e?.msg);
      return false;
    }
  };

//logout
export const logout_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.LOGOUT_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.logout, data);
    if (response.status) {
      await localStorage.removeItem("jigsawUser");
      dispatch({
        type: authConstants.LOGOUT_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: authConstants.USER_META_DATA_SUCCESS,
        payload: {},
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.LOGOUT_USER_ACTION_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//user role select
export const select_role_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.SELECT_ROLE_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.selectRole, data);

    if (response.status) {
      const user = JSON.parse(localStorage.getItem("jigsawUser"));
      user.user["role"] = data.role;
      localStorage.setItem("jigsawUser", JSON.stringify(user));
      dispatch({
        type: authConstants.SELECT_ROLE_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: authConstants.USER_META_DATA_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.SELECT_ROLE_USER_ACTION_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// google login action
export const google_login_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.GOOGLE_LOGIN_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.googleLogin, data);
    if (response.status) {
      localStorage.setItem("jigsawUser", JSON.stringify(response.data));
      dispatch({
        type: authConstants.GOOGLE_LOGIN_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: authConstants.USER_META_DATA_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.GOOGLE_LOGIN_USER_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// google login action
export const microsoft_login_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.MICROSOFT_LOGIN_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.microsoftLogin, data);
    if (response.status) {
      localStorage.setItem("jigsawUser", JSON.stringify(response.data));
      dispatch({
        type: authConstants.MICROSOFT_LOGIN_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: authConstants.USER_META_DATA_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.MICROSOFT_LOGIN_USER_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// google login action
export const user_meta_data_action = () => async (dispatch) => {
  dispatch({
    type: authConstants.USER_META_DATA_REQUEST,
  });
  try {
    const response =
      (await localStorage.getItem("jigsawUser")) &&
      JSON.parse(localStorage.getItem("jigsawUser"));
    dispatch({
      type: authConstants.USER_META_DATA_SUCCESS,
      payload: response?.user,
    });
  } catch (e) {
    dispatch({
      type: authConstants.USER_META_DATA_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// google login action
export const update_user_meta_data_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.UPDATE_USER_META_DATA_REQUEST,
  });

  try {
    const response = await axiosInstance.put(config.auth.onBoard, data);
    dispatch({
      type: authConstants.UPDATE_USER_META_DATA_SUCCESS,
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: authConstants.UPDATE_USER_META_DATA_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// google login action
export const get_loggedin_user_meta_data_action = () => async (dispatch) => {
  dispatch({
    type: authConstants.GET_LOGGEDIN_USER_META_DATA_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.auth.loggedInUser);
    if (response.status) {
      dispatch({
        type: authConstants.GET_LOGGEDIN_USER_META_DATA_SUCCESS,
        payload: response.data,
      });

      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.GET_LOGGEDIN_USER_META_DATA_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// update timezone
export const update_user_timezone_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.UPDATE_USER_TIMEZONE_REQUEST,
  });

  try {
    const response = await axiosInstance.post(config.auth.timezone, data);
    dispatch({
      type: authConstants.UPDATE_USER_TIMEZONE_SUCCESS,
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: authConstants.UPDATE_USER_TIMEZONE_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//reset password confirm
export const invite_password_reset_confirm_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      `${config.auth.invitePasswordReset}${data.uid}/${data.token}/`,
      data
    );

    if (response.status) {
      showSuccessMessage("Password has been reset succcessfully, start by loggin in.");
      dispatch({
        type: authConstants.INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return true;
    } else {
      return false;
    }

  } catch (e) {
    dispatch({
      type: authConstants.INVITE_PASSWORD_RESET_CONFIRM_USER_ACTION_FAILURE,
      payload: e,
    });
    showWarningMessage(e?.msg);
    return false;
  }
};

